import "objectFitPolyfill";

class FitImageModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.initFitImages();
    }

    bindUI() {
        this.ui = {};
        this.ui.$images = document.querySelectorAll('.js-image-fit');
    }

    initFitImages() {
        objectFitPolyfill(this.ui.$images);
    }
}

export default FitImageModule;
